"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// Same as 'useDir'. Export to avoid breaking change.
// 'useRtl' is incorrect naming, since applies that the returned value is `true` or `false`.
// but instead, it is returning `ltr` or `rtl`.
/**
 * @hidden
 */
function useRtl(elementRef, initialDir, args) {
    // Dir prop is read only on initial rendering due to specifics of getComputedStyles - see below
    var _a = React.useState(initialDir), dir = _a[0], setDir = _a[1];
    React.useEffect(function () {
        if (!dir && window && elementRef.current) {
            // Note: getComputedStyle forces reflow
            var rtlCandidate = window.getComputedStyle(elementRef.current).direction;
            if (rtlCandidate) {
                // rerender is needed as DOM is read after first render
                setDir(rtlCandidate);
            }
        }
    }, args);
    return dir;
}
exports.useRtl = useRtl;
//# sourceMappingURL=useRtl.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-common@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-common/dist/npm/hooks/useRtl.js
// module id = 6470
// module chunks = 0